import React, { memo, useMemo } from 'react';
import { TableRowBlokProps } from './TableRowBlokProps.interface';
import { storyblokEditable } from 'gatsby-source-storyblok';
import classNames from 'classnames';

interface TableRowProps {
  blok: TableRowBlokProps;
}

const TableRow: React.FC<TableRowProps> = ({ blok }) => {
  const { left_side_value, right_side_value, table_layout } = blok;

  const leftSideColSpan = useMemo(() => {
    if (table_layout === '25-75') return 1;
    if (table_layout === '50-50') return 2;
    if (table_layout === '75-25') return 3;
  }, [right_side_value, table_layout]);

  const rightSideColSpan = useMemo(() => {
    if (table_layout === '25-75') return 3;
    if (table_layout === '50-50') return 2;
    if (table_layout === '75-25') return 1;
  }, []);

  return (
    <tr
      {...storyblokEditable(blok)}
      className="w-full bg-surface/background text-text/body-tint"
    >
      <td
        className="p-3 border border-border/default"
        colSpan={leftSideColSpan}
      >
        {left_side_value}
      </td>
      <td
        className="p-3 border border-border/default"
        colSpan={rightSideColSpan}
      >
        {right_side_value}
      </td>
    </tr>
  );
};

export default memo(TableRow);
